import { render, staticRenderFns } from "./MenuCartCallWaiter.vue?vue&type=template&id=10b6a910&"
import script from "./MenuCartCallWaiter.vue?vue&type=script&lang=ts&setup=true&"
export * from "./MenuCartCallWaiter.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./MenuCartCallWaiter.vue?vue&type=style&index=0&id=10b6a910&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports